(ns hai.web-app.platform
  (:require
   [clojure.string :as str]))

(def origin
  "The origin this page was served from; the web-app answers on more than one."
  js/window.location.origin)

(defn url [& parts]
  (str
   origin
   (when (and (first parts) (not= \/ (ffirst parts)))
     "/")
   (str/join "/" parts)))
